import { Helmet } from "react-helmet-async";
import { Canvas } from '@react-three/fiber'
import { ScrollControls } from '@react-three/drei'
import AudioExperience from '../components/audio/AudioExperience'
import AudioHUD from '../components/audio/AudioHUD'
import { AudioMobile } from '../components/audio/AudioMobile'
import { AudioScenes2DOverlay } from '../components/audio/AudioScenes2DOverlay'
import useWindowDimensions from '../hooks/useWindowDimension'

export default function Audio() {
  const { width } = useWindowDimensions()
  // Phones are narrow (aspect < 1), so a fixed vertical FOV leaves very
  // little horizontal frustum width — content that fits on desktop spills
  // off the sides. Pull the camera back so the same scene geometry occupies
  // a smaller fraction of the screen.
  const isMobile = width < 768
  const camZ = isMobile ? 8 * 2.2 : 8

  const meta = (
    <Helmet>
      <title>Audio — Shreeram Ganeshan</title>
      <meta name="description" content="An interactive 3D audio visualiser — explore waveforms, synthesis, and spatial sound in a WebGL experience." />
      <meta property="og:title" content="Audio — Shreeram Ganeshan" />
      <meta property="og:description" content="Interactive 3D audio visualiser built with React Three Fiber and WebAudio." />
      <meta property="og:url" content="https://shreeram.dev/audio" />
    </Helmet>
  )

  // Mobile gets a normally-scrolling, SVG-only column layout instead of the
  // fixed-viewport WebGL cross-fade below — desktop is unchanged.
  if (isMobile) {
    return (
      <div className="audio-page">
        {meta}
        <AudioMobile />
      </div>
    )
  }

  return (
    <div className="audio-page" style={{ width: '100vw', height: '100vh', overflow: 'hidden' }}>
      {meta}
      <Canvas
        camera={{ fov: 55, near: 0.1, far: 600, position: [0, 0, camZ] }}
        style={{ background: '#020212' }}
        gl={{ preserveDrawingBuffer: true, antialias: true }}
      >
        <fog attach="fog" args={['#020212', 20, 60]} />
        <ScrollControls pages={14} damping={0.18} distance={1} style={{ scrollbarWidth: 'none', msOverflowStyle: 'none' }}>
          <AudioExperience />
        </ScrollControls>
      </Canvas>
      <AudioScenes2DOverlay />
      <AudioHUD />
    </div>
  )
}
